import { Card, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { AssignUsersToSecondaryCategoryPresenter } from '@webapp/modules/purchasing/features/assign-users-to-secondary-category'
import { CatalogPermissionSecondaryCategoryConfigListPresenter } from '@webapp/modules/purchasing/features/list-catalog-permission-secondary-category-configs'
import messages from './messages'
import { useCatalogSecondaryCategoryAccessSection } from './useCatalogSecondaryCategoryAccessSection'

export const CatalogSecondaryCategoryAccessSection = () => {
  const intl = useProcurifyIntl()
  const {
    states: { selectedSecondaryCategory, selectedSecondaryCategoryId },
    commands: { onSelectSecondaryCategory, onCancel },
  } = useCatalogSecondaryCategoryAccessSection()

  return (
    <Space direction='horizontal' align='start' size='large'>
      <Space.Item width='30%'>
        <Card>
          <Card.Content>
            <CatalogPermissionSecondaryCategoryConfigListPresenter
              selectedSecondaryCategoryId={selectedSecondaryCategoryId}
              onSelectSecondaryCategory={onSelectSecondaryCategory}
            />
          </Card.Content>
        </Card>
      </Space.Item>

      <Space.Item width='70%'>
        <Card>
          <Card.Content>
            {selectedSecondaryCategory !== null ? (
              <AssignUsersToSecondaryCategoryPresenter
                secondaryCategory={selectedSecondaryCategory}
                onCancel={onCancel}
              />
            ) : (
              <Space align='center' justify='center'>
                <Text>
                  {intl.formatMessage(
                    messages.selectSecondaryCategoryPlaceholder
                  )}
                </Text>
              </Space>
            )}
          </Card.Content>
        </Card>
      </Space.Item>
    </Space>
  )
}

CatalogSecondaryCategoryAccessSection.displayName =
  'CatalogSecondaryCategoryAccessSection'
